export const GRADES = [
  { key: "urgent_improvement", label: "Urgent Improvement", dot: "#DC2626", description: "The provider is failing learners and apprentices. Serious weaknesses exist that undermine outcomes, safety or the quality of education. Swift, wholesale action is essential." },
  { key: "needs_attention", label: "Needs Attention", dot: "#D97706", description: "Provision is not yet meeting the expected standard. Identified weaknesses are affecting learner and apprentice outcomes and require prompt, focused improvement." },
  { key: "expected_standard", label: "Expected Standard", dot: "#2563EB", description: "The provider meets the expected standard. Learners' and apprentices' outcomes, experiences and progression are secure across most measures, and leaders act on known weaknesses." },
  { key: "strong_standard", label: "Strong Standard", dot: "#059669", description: "Provision is consistently strong. Leaders demonstrate clear, sustained impact and outcomes exceed the expected standard for the great majority of learners and apprentices." },
  { key: "exceptional", label: "Exceptional", dot: "#4F46E5", description: "Provision is exemplary and a sector reference point. Practice is embedded, systemic and impactful, and learners and apprentices consistently achieve outstanding outcomes." },
];

export const gradeDescriptor = (k) => GRADES.find((g) => g.key === k)?.description || "";

export const RAG = [
  { key: "red", label: "Red — at risk" },
  { key: "amber", label: "Amber — in progress" },
  { key: "green", label: "Green — on track" },
  { key: "blue_complete", label: "Blue — complete" },
];

export const ROLES = [
  { key: "admin", label: "Admin" },
  { key: "quality_lead", label: "Quality Lead" },
  { key: "curriculum_manager", label: "Curriculum Manager" },
  { key: "contributor", label: "Contributor" },
  { key: "viewer", label: "Viewer" },
];

export const gradeLabel = (k) => GRADES.find((g) => g.key === k)?.label || k;
export const roleLabel = (k) => ROLES.find((r) => r.key === k)?.label || k;

export const canEdit = (role) => ["admin", "quality_lead", "curriculum_manager", "contributor"].includes(role);
export const canManage = (role) => ["admin", "quality_lead"].includes(role);
